import React from 'react';
import { Grid, withStyles } from '@material-ui/core';
import Online from './Online';
import Level from './Level';
import CourseDuration from './CourseDuration';
import Includes from './Includes';

const FlashCard = ({classes, level, courseDuration, data}) => (
  <Grid container spacing={3} className={classes.root}>
    <Grid item xs={12}>
      <Online />
    </Grid>
    <Grid item xs={12}>
      <Level value={level}/>
    </Grid>
    {courseDuration && <Grid item xs={12}>
      <CourseDuration value={courseDuration}/>
    </Grid>}
    <Grid item xs={12}>
      <Includes items={data.includes} />
    </Grid>
  </Grid>
);

const styles = theme => ({
  root: {
    [theme.breakpoints.between('xs', 'sm')]: {
      backgroundColor: theme.palette.secondary.surface
    }
  }
});

export default withStyles(styles)(FlashCard);
